import { jsx } from "react/jsx-runtime";
import { useContext, createContext, useMemo } from "react";
const CountryCodeContext = createContext(
  void 0
);
const CountryCodeProvider = ({
  children,
  countryCode
}) => {
  const value = useMemo(() => ({ countryCode }), [countryCode]);
  return /* @__PURE__ */ jsx(CountryCodeContext.Provider, { value, children });
};
function useCountryCode() {
  const context = useContext(CountryCodeContext);
  return context?.countryCode;
}
export {
  CountryCodeProvider,
  useCountryCode
};
//# sourceMappingURL=country-code-context.js.map
